let observerAnnounce = new MutationObserver(checkForElementAnnounce);
    const configAnnounce = { childList: true, subtree: true };
    observerAnnounce.observe(document.body, configAnnounce);
    function checkForElementAnnounce() {
    let elementAnnounce = document.querySelector('[data-announcement-date]');
    if (elementAnnounce) {
        observerAnnounce.disconnect(); // Stop the MutationObserver
        announcementDate();
    }
} 
function announcementDate() {
    const announcementDateElement = document.querySelector('[data-announcement-date]');
    const countDownDateStr = announcementDateElement.getAttribute('data-announcement-date');
    // Convert the string to a Date object
    const countDownDate = new Date(countDownDateStr);
    if (document.querySelector('.countdown')) {
        const countdown = document.querySelector('.countdown');
        const dayscontainer = countdown.querySelector('.js-days span');
        const hourscontainer = countdown.querySelector('.js-hours span');
        const minutescontainer = countdown.querySelector('.js-minutes span');
        const secondscontainer = countdown.querySelector('.js-seconds span');
        const startCountdown = () => {
            const timer = setInterval(function () {
                // Get today's date and time
                let now = new Date().getTime();
                // Find the distance between now and the count down date
                let distance = countDownDate - now;
                if (distance < 0) {
                    countdown.remove()
                    clearInterval(timer);
                }
                // Time calculations for days, hours, minutes and seconds
                let days = Math.floor(distance / (1000 * 60 * 60 * 24));
                let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((distance % (1000 * 60)) / 1000);
                // Convert numbers to two digits format
                days = String(days).padStart(2, '0');
                hours = String(hours).padStart(2, '0');
                minutes = String(minutes).padStart(2, '0');
                seconds = String(seconds).padStart(2, '0');
                // Display the result in the element with id="demo"
                dayscontainer.innerHTML = days;
                hourscontainer.innerHTML = hours;
                minutescontainer.innerHTML = minutes;
                secondscontainer.innerHTML = seconds;
                // If the count down is finished, write some text
            }, 1000);
        }
        startCountdown();
    }
}

const announcementCarousel = document.querySelector('[data-announcement-slider]')
if(announcementCarousel) {
    var swiper = new Swiper(announcementCarousel, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed:1000,
        autoplay: 
        {
          delay: 3000,
        },
        navigation: {
            nextEl: document.querySelector('[data-announcement-slide-next]'),
            prevEl: document.querySelector('[data-announcement-slide-prev]'),
          },
    });
}